import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {withRouter} from "react-router-dom";
import { fetchPromotionType } from "../../../actions/promotionAction";


import { getlanguagelist } from "../../../helpers/changelanguage";

class Remainingpromotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userImage              : '',
      userName               : '',
      userMembership         : '',
      userId                 : '',
      isToggle               : false,
      friend_notification    : 0,
      other_notification     : 0,
      total_notifiaction     : 0,
      chat_notification      : 0,
      groupchat_notification : 0,

    };
   
  }
  componentDidMount(){
   this.props.fetchPromotionType();
  }
  UNSAFE_componentWillReceiveProps(nextProps){ 
    
  }
 

  viewChat(){
    
   
  }
  render() {
  
    let  languagelist = getlanguagelist();
    let  type = ((Object.keys(this.props.promotionType).length > 0) && this.props.promotionType.promotion_type.budget_type != 'Paid') ? this.props.promotionType.promotion_type.remaining_promotion : 0;
    
    return (
        <div className="promotion_ad_box">
            <img src="/assets/images/loud_icon.png" />
            <h4>{languagelist.promotion_1} 
                <br/> <b>{type} {languagelist.promotion_2} </b><br/>{languagelist.promotion_3}
            </h4>
        </div>
    );
  };
}
const mapStateToProps = state => {
  return {
          promotionType      : state.promotiontype.promotionType,

         }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchPromotionType          : bindActionCreators(fetchPromotionType, dispatch),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Remainingpromotion));
